export class GlobalApi {
    constructor(globalClient) {
        this.globalClient = globalClient;
    }
    request(path, method, headers, data, uuid) {
        return this.globalClient.request({
            path,
            method,
            headers,
            data,
            queryParameters: undefined,
            contentType: undefined,
            uuid,
        });
    }
}
